<template>
  <div id="modalEditNum" class="modal fade" aria-hidden="true">
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical-center modal-sm"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("order.编辑采购数量") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <form>
            <div class="form-group row">
              <label
                for="iptPrice"
                class="
                  col-md-4 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("order.SKU供应商") }}</label
              >
              <div class="col-md-8 col-sm-12">
                <p class="mg-b-0">{{ item._name }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptPrice"
                class="
                  col-md-4 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("rm.当前采购数量") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <p class="mg-b-0">{{ item.quantity }}</p>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="iptQuantity"
                class="
                  col-md-4 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("order.采购数量") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <input
                  type="text"
                  name="quantity"
                  id="iptQuantity"
                  class="form-control form-control-sm"
                  v-model="quantity"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("order.保存") }}
          </button>
          <button
            type="button"
            data-dismiss="modal"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
          >
            {{ $t("order.取消") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      quantity: "",
    };
  },
  watch: {
    quantity(q) {
      this.quantity = q.replace(/[^\d]+/g, "");
    },
  },
  mounted() {
    $("#modalEditNum").on("hidden.bs.modal", (e) => {
      this.quantity = "";
    });
  },
  methods: {
    save() {
      this.$parent.loading = true;
      $.api_call(
        "api.SupplierPurchaseOrder.modifySkuQuantity",
        {
          code: this.item._code,
          supplierStockId: this.item.id,
          quantity: Number(this.quantity),
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.修改成功"), "success");
            $("#modalEditNum").modal("hide");
            setTimeout(() => {
              this.$parent.getRMOrder(true);
            }, 1000);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>